"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AuthLogin;
exports.getRuntimeRedirectUrl = getRuntimeRedirectUrl;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _webApiClient = _interopRequireDefault(require("@jusda-tools/web-api-client"));
var _LoginAnimate = _interopRequireDefault(require("./LoginAnimate.js"));
var _jusdaPublicmethod = require("@jusda-tools/jusda-publicmethod");
var _envConfig = _interopRequireDefault(require("./envConfig.js"));
var _token = require("./token.js");
var _jusdaUserInfo = _interopRequireDefault(require("./jusdaUserInfo.js"));
var _utils = require("./utils.js");
var cookieTools = new _jusdaPublicmethod.CookieTools();
var loginAnimate = new _LoginAnimate["default"]();
var jusdaUserInfo = new _jusdaUserInfo["default"]();
var isMobile = window.jusdaBaseConfig.isMobile;
var authUrl = _envConfig["default"].authUrl,
  getTokenUrl = _envConfig["default"].getTokenUrl,
  getUserInfoUrl = _envConfig["default"].getUserInfoUrl,
  authMobileUrl = _envConfig["default"].authMobileUrl;
function getReplaceCodeRegexp() {
  var verificationCode = (0, _utils.getUrlParam)(window.location.href, 'code').replace('#', '').replace('/', '');
  var regexp = new RegExp("[/?, /&]code=\\w{".concat(verificationCode.length, "}([/?,/&]state=\\w*)"), 'mg');
  return regexp;
}
function AuthLogin(_x) {
  return _AuthLogin.apply(this, arguments);
} //  获取用户信息
function _AuthLogin() {
  _AuthLogin = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(coverRedirectUrl) {
    var token, verificationCode, ignoreType, href, response, data, success;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          token = _token.tokenFn.getToken();
          verificationCode = (0, _utils.getUrlParam)(window.location.href, 'code'); // 个人中心绑定微信后由于微信返回的参数是code，和juslink的令牌换token的参数 重名，所以在绑定微信时增加ignoreType参数来做区分，
          // 有ignoreType这个参数时，就不需要去做code换token操作了
          ignoreType = (0, _utils.getUrlParam)(window.location.href, 'ignoreType');
          href = window.location.href; // 登录中
          if (!(verificationCode && ignoreType !== 'codeToToken')) {
            _context.next = 30;
            break;
          }
          // 显示登录动画 (移动端无动画)
          !isMobile && loginAnimate.show();
          cookieTools.remove(_jusdaPublicmethod.JUSDATOKEN);
          // 移除tab页的身份ID
          sessionStorage.removeItem(_jusdaPublicmethod.UserIdentityId_Tab);
          // 登录动画至少显示一秒 (移动端无动画)
          _context.t0 = !isMobile;
          if (!_context.t0) {
            _context.next = 12;
            break;
          }
          _context.next = 12;
          return new Promise(function (resolve) {
            return setTimeout(resolve, 1000);
          });
        case 12:
          _context.next = 14;
          return _webApiClient["default"].get("".concat(getTokenUrl, "?code=").concat(verificationCode, "&authorization_type=").concat(jusdaBaseConfig.responseType || '', "&client_id=").concat(jusdaBaseConfig.clientId || '', "&client_secret=").concat(jusdaBaseConfig.appId || ''));
        case 14:
          response = _context.sent;
          ;
          if (response) {
            _context.next = 18;
            break;
          }
          return _context.abrupt("return", goAuth(coverRedirectUrl));
        case 18:
          data = response.data, success = response.success; // token获取失败
          if (success) {
            _context.next = 23;
            break;
          }
          return _context.abrupt("return", goAuth(coverRedirectUrl));
        case 23:
          _context.next = 25;
          return _token.tokenFn.setToken(data);
        case 25:
          // 隐藏登录动画 (移动端无动画)
          !isMobile && loginAnimate.hide();
          _context.next = 28;
          return getUserInfo(coverRedirectUrl);
        case 28:
          window.history.pushState({}, null, href.replace(getReplaceCodeRegexp(), ''));
          // window.location.href = href.replace(getReplaceCodeRegexp(), '');
          return _context.abrupt("return", Promise.resolve());
        case 30:
          if (token) {
            _context.next = 32;
            break;
          }
          return _context.abrupt("return", goAuth(coverRedirectUrl));
        case 32:
          _context.next = 34;
          return getUserInfo(coverRedirectUrl);
        case 34:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _AuthLogin.apply(this, arguments);
}
function getUserInfo(_x2) {
  return _getUserInfo.apply(this, arguments);
}
function _getUserInfo() {
  _getUserInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(coverRedirectUrl) {
    var userInfoRes, success, errorCode, data, userIdentityId;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return _webApiClient["default"].get(getUserInfoUrl);
        case 2:
          userInfoRes = _context2.sent;
          if (userInfoRes) {
            _context2.next = 6;
            break;
          }
          jusdaUserInfo.logout(coverRedirectUrl);
          return _context2.abrupt("return", Promise.reject());
        case 6:
          success = userInfoRes.success, errorCode = userInfoRes.errorCode, data = userInfoRes.data;
          if (!(['403', '401'].includes(errorCode) || !success)) {
            _context2.next = 10;
            break;
          }
          jusdaUserInfo.logout(coverRedirectUrl);
          return _context2.abrupt("return", Promise.reject());
        case 10:
          // 增加用户身份ID以备后续校验，防止因用户信息污染导致的业务问题
          if (success && data) {
            userIdentityId = data.userIdentity ? data.userIdentity.userIdentityId : undefined;
            sessionStorage.setItem(_jusdaPublicmethod.UserIdentityId_Tab, userIdentityId);
            cookieTools.set({
              // eslint-disable-next-line @typescript-eslint/camelcase
              key: _jusdaPublicmethod.UserIdentityId_Newest,
              value: userIdentityId
            });
            (0, _utils.monitorWindowStatus)();
          }
          window.jusdaUserInfo = userInfoRes;
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getUserInfo.apply(this, arguments);
}
function getRuntimeRedirectUrl() {
  var redirectUrl = window.location.origin + window.location.pathname + window.location.hash;
  // ignoreType参数为绑定微信时加的特殊参数(因为微信绑定时返回的url上也会带一个微信的code与统一登录的code参数key重复了，所以增加ignoreType参数来区分)
  // 但在微信绑定时如果登录信息已经过期，返回登录流程就需要去掉这个参数，不然无法正常走code换token的流程
  if (redirectUrl.includes('ignoreType')) {
    redirectUrl = (0, _utils.removeParameters)(redirectUrl, ['ignoreType']);
  }
  return decodeURIComponent(redirectUrl).replace(getReplaceCodeRegexp(), '');
}
function goAuth(coverRedirectUrl) {
  cookieTools.remove(_jusdaPublicmethod.JUSDATOKEN);
  var _window = window,
    jusdaBaseConfig = _window.jusdaBaseConfig;
  var redirectUrl = coverRedirectUrl && coverRedirectUrl.length > 0 ? coverRedirectUrl : getRuntimeRedirectUrl();
  window.location.href = "".concat(isMobile ? authMobileUrl + '?clientId=' + jusdaBaseConfig.clientId : authUrl, "&redirectUrl=").concat(encodeURIComponent("".concat(redirectUrl)), "&state=").concat(jusdaBaseConfig ? jusdaBaseConfig.state || 'placeholder' : 'placeholder', "&responseType=").concat(jusdaBaseConfig ? jusdaBaseConfig.responseType || 'code' : 'code', "&scopeCodes=").concat(jusdaBaseConfig ? jusdaBaseConfig.scopeCodes || '' : '', "&t=").concat(new Date().getTime());
  return Promise.reject();
}